import { FormModel } from 'main/common/form-state-manager/FormModel'
import { IsNotEmpty } from 'main/common/validation/decorators/IsNotEmpty'

export class NewSmsFormValidator extends FormModel {

    @IsNotEmpty()
    content: string

    @IsNotEmpty()
    segmentCode: number

    @IsNotEmpty()
    franchisesCodes: number[]

    constructor(initialData?: any) {
        super(initialData)
        Object.assign(this, initialData)
    }

}
